import {useQuery} from "@tanstack/react-query";
import useUserInfo from "../useUserInfo";
import type {UseQueryOptions} from "@tanstack/react-query/src/types";
import {BindInfoType, BindItemType} from "../../types/types";
import {getBindInfoApi, getBindListApi} from "../../api";

export {bindCexApi, unBindApi, unBindWalletApi} from "../../api";

export function useBindList(options?: Partial<Omit<UseQueryOptions<BindItemType[]>, 'queryKey' | 'queryFn'>>) {
    const {isLogin} = useUserInfo()
    return useQuery<BindItemType[]>({
        queryKey: ['bindList'],
        enabled: isLogin,
        queryFn: async () => {
            let res = await getBindListApi()
            return res.data
        },
        ...options
    })
}

export function useBindInfo(options?: Partial<Omit<UseQueryOptions<BindInfoType>, 'queryKey' | 'queryFn'>>) {
    const {isLogin} = useUserInfo()
    return useQuery<BindInfoType>({
        queryKey: ['bindInfo'],
        enabled: isLogin,
        queryFn: async () => {
            let res = await getBindInfoApi()
            return res.data
        },
        ...options
    })
}
